export default __webpack_public_path__ + "static/media/SJA1280.34I-38818_-22733_0.720121f3.jpg";